import every from 'lodash/every'

import { CustomerAddress } from '../../../../../types/customerForm'

export const isShippingAddressSynced = (
  shippingAddress: CustomerAddress | undefined,
  address: CustomerAddress | undefined,
): boolean => {
  if (!shippingAddress) {
    return false
  }

  return every(address, (value, key) => shippingAddress[key as keyof CustomerAddress] === value)
}
